export default __webpack_public_path__ + "static/media/8.5af0e5e0.jpg";